/**
 * 格式化货币金额
 * @param amount - 金额数字
 * @returns 格式化后的字符串，例如：1,234.56
 */
export function formatCurrency(amount: number): string {
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
